import React from 'react'

const Card_5 = (props) => {
    const { icon, title, subTitle } = props;
    return (
        <div className="has_fade_anim h-100">
            <div className="integration-card h-100">
                <div className="thumb">
                    <img src={icon} alt="icon image"/>
                </div>
                <div className="content">
                    <h3 className="title fs-1 text-grad-3">
                        {title}
                    </h3>
                    <p className="text fs-3 text-gray-900">
                        {subTitle}
                    </p>
                    <span className="wc-btn wc-btn-normal fs-4 text-gray-800">
                        READ MORE
                        <i className="fa-solid fa-arrow-right"></i>
                    </span>
                </div>
            </div>
        </div>
        
    )
}

export {Card_5}